// extracted by mini-css-extract-plugin
export var marginNegative = "_7e-5 _7e-3 _7e-1";
export var marginPositive = "_7e-4 _7e-3 _7e-1";
export var modalContent = "_7e-6";
export var samplesTable = "_7e-8";
export var samplesTableContainer = "_7e-7";
export var statBox = "_7e-a";
export var tableCell = "_7e-1";
export var tableCellCenter = "_7e-2 _7e-1";
export var tableCellRight = "_7e-3 _7e-1";
export var tableHeader = "_7e-0";
export var trackingNumber = "_7e-9";